import React from "react";

export const ALERT_DANGER = "danger";
export const ALERT_WARNING = "warning";
export const ALERT_SUCCESS = "success";

interface AlertProps {
	children: React.ReactNode;
	onClose?(): void;
	severity: typeof ALERT_DANGER | typeof ALERT_WARNING | typeof ALERT_SUCCESS;
}

export default function Alert({ onClose, children, severity }: AlertProps) {
	let title = "";
	let icon = "";

	switch (severity) {
		case ALERT_DANGER:
			title = "Error";
			icon = "fe fe-alert-triangle";
			break;

		case ALERT_WARNING:
			title = "Warning";
			icon = "fe fe-alert-circle";
			break;

		case ALERT_SUCCESS:
			title = "Success";
			icon = "fe fe-check-circle";
			break;

		default:
			break;
	}

	return (
		<div className={`alert alert-${severity}`}>
			<div className="alert-header">
				<span className={`alert-icon ${icon}`}></span>
				{title && <span className="alert-title">{title}</span>}
				{onClose && (
					<button
						type="button"
						className="btn btn-close"
						onClick={onClose}
					>
						Remove alert
					</button>
				)}
			</div>
			{children && <div className="alert-content">{children}</div>}
		</div>
	);
}
